__turbopack_context__.v({
  "icon": "icon-module__Zh2sZq__icon",
});
